import React, { useState } from "react";
import TermsEditor from "../dynamic-pages/TermsEditor";
import PrivacyEditor from "../dynamic-pages/PrivacyEditor";
import FaqEditor from "../dynamic-pages/FaqEditor";

const DynamicPages = () => {
  const [activePage, setActivePage] = useState("");

  const renderEditor = () => {
    switch (activePage) {
      case "terms":
        return <TermsEditor />;
      case "privacy":
        return <PrivacyEditor />;
      case "faq":
        return <FaqEditor />;
      default:
        return (
          <p className="text-gray-500 text-center py-8 border rounded bg-gray-50">
            Please select a page to view and edit its content.
          </p>
        );
    }
  };

  return (
    <div className="p-6 max-w-4xl mx-auto">
      <h1 className="text-2xl font-bold mb-6">Manage Dynamic Pages</h1>

      <div className="mb-6">
        <label className="block mb-2 font-semibold text-gray-700">
          Select Page to Edit:
        </label>
        <select
          className="border border-gray-300 rounded px-4 py-2 w-full max-w-md"
          value={activePage}
          onChange={(e) => setActivePage(e.target.value)}
        >
          <option value="">-- Select Page --</option>
          <option value="terms">Terms & Conditions</option>
          <option value="privacy">Privacy Policy</option>
          <option value="faq">FAQs</option>
        </select>
      </div>

      <div className="bg-white p-6 rounded shadow border border-gray-200">
        {renderEditor()}
      </div>
    </div>
  );
};

export default DynamicPages;
